var Save = require('RecordSave');
var Status = require('RecordStatus');

module.exports.run = function (options) {

    Status.set(options);
    return Save.run(options);
};


// WEBPACK FOOTER //
// ./js/Modules/Record/Action/RecordActionSave.js